<template>

    <div class="stages-detail-page admin-page">
        <Header></Header>
        <vue-ins-progress-bar></vue-ins-progress-bar>
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <router-link class="next-icon add-btn" :to="`/admin/artist/`+artistId+`/stages/`"><img src="@/assets/img/prev.svg"/> Stages List</router-link>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Edit Stage</h2>
                        <form class="form" v-on:submit.prevent="stageFormSubmit" enctype="multipart/form-data">
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Matisse" v-model="title" id="your-title">
                            </div>
                            <div class="input-field form-input">
                                <label for="youtubeurl">You Tube Link *</label>
                                <input type="text" placeholder="You Tube Link" v-model="youtubeurl" id="youtubeurl">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Video Cover Image *</p>
                                <label for="bg-image">
                                    <span>{{videoImageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="bg-image" ref="videoImageFile" v-on:change="handlevideoImageFileUpload">
                            </div>
                            <div class="input-tags-field form-input">
                                <label>Skills *</label>
                                <tags-input element-id="tags"
                                            v-model="selectedTags"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            @tags-updated="tagFunction"
                                            :existing-tags="$options.skills"
                                            :typeahead="true"></tags-input>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-description">Description *</label>
                                <textarea placeholder="Description" id="your-description" v-model="description" style="min-height: 150px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna nibh, viverra non, semper suscipit, posuere a, pede.</textarea>
                            </div>
                            <div class="input-field form-input">
                                <label for="isfeatured">Is Featured</label>
                                <input type="checkbox" v-model="isfeatured" id="isfeatured">
                            </div>
                            <div class="input-submit">
                                <input type="hidden" :value="videoId"/>
                                <input type="hidden" :value="stageId"/>
                                <button type="submit" v-if="!submitOnce">SUBMIT</button>
                                <span v-if="submitOnce">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<style>
    @import "../../../assets/css/tagsinput.css";
</style>

<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import router from '../../../router'
    import Vue from 'vue'
    import VueInsProgressBar from 'vue-ins-progress-bar'
    import axios from 'axios'
    import skills from '@/assets/skills.json'
    const options = {
        position: 'fixed',
        show: true,
        height: '5px'
    }
    Vue.use(VueInsProgressBar, options)

    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    import backgroundUrl from '@/assets/img/image6.jpg'
    import backgroundUrl2 from '@/assets/img/image1.jpg'
    import backgroundUrl1 from '@/assets/img/team/dasha.png'
    import backgroundUrl4 from '@/assets/img/image4.jpg'
    import backgroundUrl5 from '@/assets/img/image5.svg'
    export default {
        name: 'StagesEdit',
        skills: skills,
        components: {
            'Header': Header,
            'Footer': Footer,
            'TagsInput': VoerroTagsInput
        },
        mounted () {
            // stageId
            axios
                .get('/getStageById', {
                    params: {
                        stageId: this.stageId
                    }
                })
                .then(response => {
                    this.title = response.data.title
                    this.isfeatured = response.data.isfeatured
                    this.description = response.data.description
                    this.youtubeurl = response.data.youtubeurl
                    // this.selectedTags = response.data.tags
                    this.videoImageName = response.data.videoId[0].videoImageName
                    this.videoName = response.data.videoId[0].videoName
                    this.videoId = response.data.videoId[0]._id

                    if(response.data.tags){
                        var list = []
                        response.data.tags.map(function(value, key) {
                            list.push({key: value, value: value})
                        })
                    }
                    this.selectedTags = list

                    var tags = []
                    this.selectedTags.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags

                })
                .catch(error => console.log(error))
        },
        methods: {
            handlevideoFileUpload(){
                this.videoFile = this.$refs.videoFile.files[0]
                this.videoName = this.$refs.videoFile.files[0].name
            },
            handlevideoImageFileUpload(){
                this.videoImageFile = this.$refs.videoImageFile.files[0]
                this.videoImageName = this.$refs.videoImageFile.files[0].name
            },
            tagFunction(msg){
                if (!this.selectedTags.length) {
                } else {
                    var tags = []
                    this.selectedTags.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            stageFormSubmit(){
                this.submitOnce = true
                this.$insProgress.start()
                if(this.videoFile || this.videoImageFile){
                    const formData = new FormData()
                    if(this.videoFile){
                        formData.append('videourl', this.videoFile)
                        formData.append('videoName', this.videoName)
                    }
                    if(this.videoImageFile){
                        formData.append('videoImageFile', this.videoImageFile)
                        formData.append('videoImageName', this.videoImageName)
                    }
                    formData.append('videoId', this.videoId)
                    try {
                        axios.post('/stageVideoEdit', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.stageEdit()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.stageEdit()
                }
            },
            stageEdit(){
                try {
                    axios.post('/editstage', {
                        title: this.title,
                        description: this.description,
                        youtubeurl: this.youtubeurl,
                        isfeatured: this.isfeatured,
                        tags: this.tags,
                        stageId: this.stageId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        console.log(res)
                        this.$insProgress.finish()
                        this.submitOnce = false
                        Vue.$toast.open(
                            {
                                message: 'Stage updated!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }).catch(err => {
                        console.log(err)
                    })
                } catch (e) {
                    console.log(e)
                }
            }
        },
        data () {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                title: '',
                selectedTags: [],
                tags: [],
                description: '',
                stageId: router.history.current.params.id,
                artistId: router.history.current.params.userId,
                videoId: '',
                videoImageFile: '',
                videoFile: '',
                videoImageName: '',
                userData: userdata,
                videoName: '',
                youtubeurl: '',
                submitOnce: false,
                isfeatured: false,
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/stages/Edit.vue